import {ErrorMessage, Field, Form, Formik} from "formik";
import postData from "../services/postData";
import Modal from "./Modal";
import {useState} from "react";
import {ScrollToFieldError} from "./formik/ScrollToFieldError";
import SkodaSecondDataInfo from "./SkodaSecondDataInfo";
import {formSchema} from "../schema/formSchema";
import SkodaDataInfo from "./SkodaDataInfo";

export default function ServiceForm({setLoadingSpinnerOpen}) {

    const [successModal, setSuccessModal] = useState(false);
    const [failureModal, setFailureModal] = useState(false);
    const [formIsSubmitting, setFormIsSubmitting] = useState(false);

    const dataLayerPush = (orderId) => {
        try {
            window.dataLayer.push({
                'event': 'formularze',
                'wypelniony-formularz': 'serwis-zamowiono',
                'orderid': orderId
            });
            console.log('dataLayer.push ok:', orderId);
        } catch (err) {
            console.error('dataLayer.push error:', err);
        }
    };

    const syneriseSendFormData = (orderId, values) => {
        if (!('SR' in window)) {
            console.error('SR undefined');
            return;
        }

        const formType = 'newsletter_otm_powerpass_sms,bp';

        const snrData = {
            orderID: orderId,
            firstname: values.firstName, //imie
            phone: values.phone, //telefon
            email: values.email, //email
            date: values.date, //dzień
            agreeData: values.agreeData ? 'true' : 'false', //zgadzam się na uzwanie przez vw group polska
            receive_smses: values.agreeCommunication.includes('sms') ? 'true' : 'false',
            phonecall: values.agreeCommunication.includes('phone') ? 'yes' : 'no',
            newsletterAgreement: values.agreeCommunication.includes('email') ? 'enabled' : 'disabled',
        };
        try {
            window.SR.event.sendFormData(formType, snrData)
                .then((res) => {
                    console.log(formType);
                    console.log(res);
                })
                .catch((err) => {
                    console.log(formType);
                    console.error(err);
                });
        } catch (err) {
            console.error('SR error', err);
        }
    };

    return (
        <Formik
            initialValues={{
                firstName: '',
                phone: '',
                email: '',
                date: '',
                agreeData: false,
                agreeCommunication: [],
            }}
            validationSchema={formSchema}
            onSubmit={(values, actions) => {
                actions.setSubmitting(false);
                setFormIsSubmitting(true);
                // console.log(values);
                // setLoadingSpinnerOpen(true);

                postData(values)
                    .then((data) => {
                        if (data && data.status === 'ok') {

                            dataLayerPush(data.orderId);
                            syneriseSendFormData(data.orderId, values);
                            actions.resetForm();
                            setSuccessModal(true);
                        } else {
                            setFailureModal(true);
                        }
                    })
                    .catch((error) => {
                        setFailureModal(true);
                    })
                    .finally(() => {
                        setFormIsSubmitting(false);
                        // setLoadingSpinnerOpen(false);
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth"
                        });
                    });
            }}
        >
            {(formikProps) => (
                <>
                    {/*{successModal && (*/}
                    {/*    window.location.href = "https://twoja.skoda.pl/brandportal/newsletter/brandportal/dziekujemy"*/}
                    {/*)}*/}
                    <Modal open={successModal} setOpen={setSuccessModal}>
                        <b>Dziękujemy za wypełnienie formularza</b>
                        <p>Do zobaczenia na transmisji!</p>
                    </Modal>

                    <Modal open={failureModal} setOpen={setFailureModal}>
                        Wystąpił błąd!<br/>
                        Prosimy spróbować później.
                    </Modal>

                    <Form className="form-container form-container js-subscribe-form" method={`post`}>
                        <ScrollToFieldError/>


                        <div className="form-row">
                            <div className="form-copy">
                                <b>Weź udział w specjalnej prezentacji usługi Powerpass w Salonie Online Škody</b>
                                <br/><br/>Podczas 20-minutowego spotkania z naszymi specjalistami odkryjemy przed Tobą, jakie są zalety posiadania karty Powerpass i jak z niej korzystać. Transmisje odbywają się codziennie o godzinie 11:00. Zapisz się na prezentację, a my wyślemy Ci przypomnienie na 5 minut przed rozpoczęciem.
                                <br/><br/>
                                Pamiętaj, by zaakceptować pliki cookie w lewym dolnym rogu ekranu, aby móc obejrzeć transmisję.                                 <br/><br/>
                            </div>
                        </div>

                            <div className="form-row">
                                <label className="form-label" htmlFor="firstName">Imię</label>
                                <Field id="firstName" name="firstName" type="text" className="form-input" maxLength={50}></Field>
                                <ErrorMessage name="firstName">{msg => <div className="form-error">{msg}</div>}</ErrorMessage>
                            </div>

                        <div className="form-row form-row--inline js-form-item-firstname">
                            <label className="form-label" htmlFor="phone">Nr telefonu*</label>
                            <Field id="phone" name="phone" type="tel" className="form-input" maxLength={9}></Field>
                            <ErrorMessage name="phone">{msg => <div className="form-error">{msg}</div>}</ErrorMessage>
                        </div>

                        <div className="form-row">
                            <label className="form-label" htmlFor="email">Email</label>
                            <Field id="email" name="email" type="email" className="form-input" maxLength={255}></Field>
                            <ErrorMessage name="email">{msg => <div className="form-error">{msg}</div>}</ErrorMessage>
                        </div>
                        {/*<div style={{paddingBottom: "10px"}}>&nbsp;</div>*/}
                        <br/>
                        <div className="form-row">
                            <label className="form-label" htmlFor="date">
                                Wybierz dzień*
                            </label>
                            <Field
                                as="select"
                                id="date"
                                name="date"
                                className="form-input"
                            >
                                <option value=""></option>
                                <option value="08.11">08.11</option>
                                <option value="09.11">09.11</option>
                                <option value="10.11">10.11</option>
                                <option value="11.11">11.11</option>
                                <option value="12.11">12.11</option>
                                <option value="13.11">13.11</option>
                                <option value="14.11">14.11</option>
                                <option value="15.11">15.11</option>
                                <option value="16.11">16.11</option>
                                <option value="17.11">17.11</option>
                                <option value="18.11">18.11</option>
                                <option value="19.11">19.11</option>
                                <option value="20.11">20.11</option>

                            </Field>
                            <ErrorMessage name="date">
                                {msg => <div className="form-error">{msg}</div>}
                            </ErrorMessage>
                        </div>
                        <SkodaSecondDataInfo/>
                        <br/>
                        <div className="form-row">
                            <div className="form-checkbox">
                                <Field className="form-check-input" id="agreeData" name="agreeData" type="checkbox"></Field>
                                <label htmlFor="agreeData" className="form-check-label">
                                    Zgadzam się na używanie przez Volkswagen Group Polska Sp. z o.o. (VGP) oraz Škoda Auto a.s. przekazanych danych, danych zebranych o moich zapytaniach i zainteresowaniach, ofertach, zamówieniach i zleceniach w ramach relacji biznesowej z VGP lub z Autoryzowanym Dealerem lub Autoryzowanym Partnerem Serwisowym, w celu marketingu dot. produktów i usług marki Škoda oraz innych powiązanych z marką Škoda akcesoriów, produktów i usług motoryzacyjnych, w tym także w celu profilowania na potrzeby marketingu oraz realizacji działań posprzedażowych polegających na prowadzeniu i analizie badań: satysfakcji klienta lub zainteresowania marką produktami i usługami marki Škoda.
                                </label>
                            </div>
                            <ErrorMessage name="agreeData">{msg => <div className="form-error">{msg}</div>}</ErrorMessage>
                        </div>

                        <p><b>Chcę otrzymać od VGP wyżej wymienione informacje handlowe i&nbsp;marketingowe poprzez:</b></p>
                        <div className="form-group">
                            <div className="form-row">
                                <div className="form-checkbox">
                                    <Field className="form-check-input" id="agreeCommunication_sms"
                                           name="agreeCommunication" value="sms" type="checkbox"></Field>
                                    <label htmlFor="agreeCommunication_sms" className="form-check-label">SMS/MMS</label>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-checkbox">
                                    <Field className="form-check-input" id="agreeCommunication_phone"
                                           name="agreeCommunication" value="phone" type="checkbox"></Field>
                                    <label htmlFor="agreeCommunication_phone"
                                           className="form-check-label">Telefon</label>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-checkbox">
                                    <Field className="form-check-input" id="agreeCommunication_email"
                                           name="agreeCommunication" value="email" type="checkbox"></Field>
                                    <label htmlFor="agreeCommunication_email" className="form-check-label">Email</label>
                                </div>
                            </div>
                            <ErrorMessage name="agreeCommunication">{msg => <div
                                className="form-error">{msg}</div>}</ErrorMessage>
                        </div>
                        <SkodaDataInfo/>
                        <br/>
                        <div className="form-row form-row--buttons">
                            <button type="submit" className="button button--primary" disabled={formIsSubmitting}>Zapisz</button>
                        </div>
                    </Form>
                </>
            )}
        </Formik>
    );
}
